import React, { useState, useEffect, useCallback } from 'react'
import NewsCard from "./newsCard"
import {Link, useNavigate} from 'react-router-dom'
import { news } from "../../../data/news"
import { getAdminNews } from "../../../services/newsServices";


const News = () => {
  const [newsList, setNewsList] = useState([]);

  const loadNews = useCallback(async () => {
    const response = await getAdminNews();
    setNewsList(response.data || []);
  }, []);

  useEffect(() => {
    loadNews();
  }, [loadNews]);

  const handleDeleted = (deletedNews) => {
    const deletedId = deletedNews._id || deletedNews.newsId;
    setNewsList((current) =>
      current.filter((item) => (item._id || item.newsId) !== deletedId)
    );
  };



  return (
    <div className='py-5 px-4 bg-slate-50 shadow-lg mx-2 rounded-md'>
        <div className='bg-slate-200 space-x-4  py-3 px-3 mx-2  flex justify-between w-full'>
                <input
                    type="text"
                    placeholder="Search Here"
                    className="relative w-full py-2 px-3 outline-none rounded-md"
                />

            <Link to="/newsEntery" className="w-fit font-medium bg-blue-700 text-white dark:text-blue-500 hover:bg-blue-900 px-3 py-1 rounded-lg shadow-lg flex justify-center items-center whitespace-nowrap ">Post a news</Link>
        </div>
        <div className="relative w-full h-fit ">
           <NewsCard news={newsList} onDeleted={handleDeleted} />
        </div>
    </div>
  )
}

export default News